import { InitPage } from "../index";
import axios from "axios";
import swal from "sweetalert";

declare let currentClientCode: string;

class SgtinSettings {
  init() {
    const _self = this;
    $("#sgtinEncodingSettingBtn").on("click", function() {
      $("#company_prefix").val("");
      _self.loadSgtinSettings();
      $("#sgtinEncodingSetting").modal("show");
    });

    $("#sgtinEncodingSettingCreateBtn").on("click", function() {
      _self.createSgtinSetting();
    });

    // Auto-update GS1 default partition settings
    $("#gs1_enable_default_partition").on("change", function() {
      _self.updateGs1DefaultPartition();
    });

    $("#gs1_default_partition").on("change", function() {
      _self.updateGs1DefaultPartition();
    });

    // Set up delete handler using document-level delegation for persistence
    $(document).off('click', '#sgtinEncodingSettingTBody .deleteRecord').on('click', '#sgtinEncodingSettingTBody .deleteRecord', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const id = $(this).data('id');
      if (id) {
        _self.removeSgtin(id);
      }
      return false;
    });
  }

  createSgtinSetting() {
    if (!$("#company_prefix").val()) {
      window.toastr_notifications.error(
        "The company prefix is required!",
        "Error",
      );
      return;
    }
    var formDataArray = $("#createSgtinSettingForm").serializeArray();
    var formDataObject = this.arrayToObject(formDataArray);
    var formDataJSON = JSON.stringify(formDataObject);
    const _self = this;
    axios
      .post(
        `/${currentClientCode}/sgtin_encoding_settings`,
        formDataJSON,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then(function(response) {
        window.toastr_notifications.success(
          "SGTIN setting created successfully!",
          "Success",
        );
        _self.loadSgtinSettings();
        $("#company_prefix").val("");
      })
      .catch(function(error) {
        window.toastr_notifications.error(error.response.data.error, "Error");
      });
  }

  removeSgtin(id) {
    const _self = this;
    swal({
      title: "Are you sure?",
      text: "This operation will delete the current row!",
      icon: "warning",
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-silver",
          closeModal: true
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-danger",
          closeModal: true
        }
      },
      dangerMode: true
    }).then((isConfirmed) => {
      if (isConfirmed) {
        axios
          .delete(
            `/${currentClientCode}/sgtin_encoding_settings/${id}`,
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          )
          .then(function(response) {
            window.toastr_notifications.success(
              "SGTIN setting deleted successfully!",
              "Success",
            );
            _self.loadSgtinSettings();
          })
          .catch(function(error) {
            window.toastr_notifications.error(error.response.data.error, "Error");
          });
      }
    });
  }

  updateGs1DefaultPartition() {
    const enableDefaultPartition = $("#gs1_enable_default_partition").is(":checked");
    const defaultPartition = $("#gs1_default_partition").val();
    
    const formData = {
      general_setting: {
        gs1_enable_default_partition: enableDefaultPartition,
        gs1_default_partition: defaultPartition
      }
    };

    // Get CSRF token from meta tag
    const csrfToken = $('meta[name="csrf-token"]').attr('content');

    axios
      .post(
        `/${currentClientCode}/general_settings/update_gs1_default_partition`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken
          },
        },
      )
      .then(function(response) {
        if (response.data.status === 'success') {
          window.toastr_notifications.success(
            "GS1 default partition settings updated successfully!",
            "Success",
          );
        } else {
          window.toastr_notifications.error(
            response.data.message || "Failed to update settings",
            "Error",
          );
        }
      })
      .catch(function(error) {
        window.toastr_notifications.error(
          error.response?.data?.message || "Failed to update GS1 default partition settings",
          "Error",
        );
      });
  }

  loadSgtinSettings() {
    const _self = this;
    axios
      .get(`/${currentClientCode}/sgtin_encoding_settings`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function(response) {
        const sgtin_encoding_settings = response.data.sgtin_encoding_settings;
        const tbody = $("#sgtinEncodingSettingTBody");
        tbody.html("");
        sgtin_encoding_settings.forEach((part) => {
          const row = document.createElement("tr");
          row.classList.add("center-content", "ui-state-default");
          row.setAttribute("id", part.id);
          row.innerHTML = `
                      <td class="drag-handle" style="cursor: move; text-align: center;">
                        <i class="fa fa-sort" style="color: #999;" title="Drag to reorder"></i>
                      </td>
                      <td>${part.partition_type}</td>
                      <td class="bold">${part.company_prefix}</td>
                      <td>${part.prefix_no_of_bits}</td>
                      <td>${part.prefix_digits}</td>
                      <td>${part.item_ref_no_of_bits}</td>
                      <td>${part.item_ref_digits}</td>
                      <td class="sn-icons">
                      <a href="#" class="fa fa-minus-circle fa-2x circle-delete-icon deleteRecord" title="Delete" data-toggle="tooltip" data-id="${part.id}"></a>
                      </td>`;
          tbody.append(row);
        });
        
        // Initialize sortable after loading data
        _self.initSortable();
      })
      .catch(function(error) {
        window.toastr_notifications.error(error.response.data.error, "Error");
      });
  }

  arrayToObject(array) {
    var result = {};
    array.forEach(function(item) {
      var keys = item.name.split("[");
      var currentObj = result;
      keys.forEach(function(key, index) {
        key = key.replace("]", "");
        if (index === keys.length - 1) {
          currentObj[key] = item.value;
        } else {
          currentObj[key] = currentObj[key] || {};
          currentObj = currentObj[key];
        }
      });
    });

    return result;
  }

  initSortable() {
    const tbody = $("#sgtinEncodingSettingTBody");
    const savePath = tbody.attr("data-save-path");
    const _self = this;
    
    // Destroy existing sortable if it exists
    if (tbody.hasClass('ui-sortable')) {
      tbody.sortable('destroy');
    }
    
    if (savePath) {
      tbody.sortable({
        handle: ".drag-handle",
        cancel: ".deleteRecord, .sn-icons, a, button",
        update: function(event, ui) {
          const rows = tbody.find("tr");
          const data = [];
          rows.each(function() {
            const id = $(this).attr("id");
            if (id) {
              data.push(parseInt(id));
            }
          });

          axios
            .post(savePath, { order: data }, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then(function(response) {
              if (response.data.success) {
                window.toastr_notifications.success(
                  "Row order updated successfully!",
                  "Success",
                );
              } else {
                window.toastr_notifications.error(
                  response.data.error || "Failed to update row order",
                  "Error",
                );
                _self.loadSgtinSettings();
              }
            })
            .catch(function(error) {
              window.toastr_notifications.error(
                error.response?.data?.error || "Failed to update row order",
                "Error",
              );
              _self.loadSgtinSettings();
            });
        }
      });
    }
  }
}

export function LoadPage() {
  InitPage("general_settings", () => {
    const sgtinSettings = new SgtinSettings();
    sgtinSettings.init();
  });
}

(window as any).sgtinSettings = new SgtinSettings();
